import { FC } from "react";

export interface Props {
	yearValue?: number;
	setYearValue: (val: number) => void;
	years: number[];
}

const YearFilter: FC<Props> = ({ yearValue, setYearValue, years }) => {
	return (
		<div data-testid="component.YearFilter">
			<div className="flex flex-row items-center">
				<select
					title="Select Year"
					data-testid="year-picker"
					className="w-full px-3 py-2.5 bg-white border border-border rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-ring focus:border-ring transition-colors"
					value={yearValue}
					onChange={(e) => setYearValue(parseInt(e.target.value))}
				>
					{years.map(
						(year) =>
							year && (
								<option className="text-sm" key={year} value={year}>
									{year}
								</option>
							)
					)}
				</select>
			</div>
		</div>
	);
};

export default YearFilter;
